// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__a4jX8","header":"Messages_header__3KU-y"};